import React from "react";
import { connect } from "react-redux";
import { t } from "ttag";

import { IProductUUID } from "../../../models/nominals";
import { TStateMapper } from "../../reducers.interfaces";
import { getAllFormSubmittedForParentUUID } from "../selectors";

interface IOwnProps {
    parentUUID: IProductUUID;
}

interface IReduxProps {
    isOpen: boolean;
}

interface IProps extends IOwnProps, IReduxProps {}

interface IState {}

// TODO(ssr, LEVEL 2 out of 10): Migrate this component from class-style to functional-style. Rated LOE as 2/10 due to 71 LOC, simple conditional rendering, Redux integration, and no complex state or lifecycle methods.
class WriteReviewMultiThankYouComponent extends React.PureComponent<
    IProps,
    IState
> {
    render() {
        if (!this.props.isOpen) {
            return null;
        }
        return (
            <div className="review-thank-you">
                <h2 className="review-thank-you__title">
                    {t`Thank You for Writing a Review`}
                </h2>
                <p>
                    {t`We appreciate your feedback and comments, and always enjoy hearing from you.`}
                </p>
                <p>
                    {t`Return to the `}
                    <a
                        title={t`Home`}
                        href="/"
                        className="review-thank-you__home"
                        target="_self"
                    >
                        {t`homepage`}
                    </a>
                    <span>.</span>
                </p>
            </div>
        );
    }
}

const mapStateToProps: TStateMapper<"reviews", IReduxProps, IOwnProps> = (
    rootState,
    ownProps,
) => {
    const allFormsSubmitted = getAllFormSubmittedForParentUUID(
        rootState.reviews,
        ownProps,
    );
    return {
        ...ownProps,
        isOpen: allFormsSubmitted,
    };
};

export const WriteReviewMultiThankYou = connect(mapStateToProps)(
    WriteReviewMultiThankYouComponent,
);
